'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowThreadListButtonWrapper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  height: 100%;\n  max-width: 15px;\n  transition: all 0.5s ease;\n  &.showThreadListButton {\n    max-width: 100px;\n  }\n'], ['\n  height: 100%;\n  max-width: 15px;\n  transition: all 0.5s ease;\n  &.showThreadListButton {\n    max-width: 100px;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _RecordPropType = require('ui-addon-conversations/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _ShowThreadListButton = require('./ShowThreadListButton');

var _ShowThreadListButton2 = _interopRequireDefault(_ShowThreadListButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ShowThreadListButtonWrapper = exports.ShowThreadListButtonWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'WidgetHeaderThreadListButton__ShowThreadListButtonWrapper'
})(_templateObject);

var WidgetHeaderThreadListButton = function (_React$Component) {
  _inherits(WidgetHeaderThreadListButton, _React$Component);

  function WidgetHeaderThreadListButton() {
    _classCallCheck(this, WidgetHeaderThreadListButton);

    return _possibleConstructorReturn(this, (WidgetHeaderThreadListButton.__proto__ || Object.getPrototypeOf(WidgetHeaderThreadListButton)).apply(this, arguments));
  }

  _createClass(WidgetHeaderThreadListButton, [{
    key: 'render',
    value: function render() {
      var textColor = this.props.coloring.textColor;
      var _props = this.props,
          showThreadList = _props.showThreadList,
          showThreadListButton = _props.showThreadListButton,
          unseenThreadsCountExcludingCurrentThread = _props.unseenThreadsCountExcludingCurrentThread;


      var ShowThreadListButtonWrapperClassNames = (0, _classNames2.default)({
        showThreadListButton: showThreadListButton
      });

      return _react2.default.createElement(
        ShowThreadListButtonWrapper,
        {
          className: ShowThreadListButtonWrapperClassNames
        },
        _react2.default.createElement(_ShowThreadListButton2.default, {
          showThreadListButton: showThreadListButton,
          unseenThreadsCountExcludingCurrentThread: unseenThreadsCountExcludingCurrentThread,
          showThreadList: showThreadList,
          activeBackgroundColor: textColor
        })
      );
    }
  }]);

  return WidgetHeaderThreadListButton;
}(_react2.default.Component);

WidgetHeaderThreadListButton.propTypes = {
  coloring: (0, _RecordPropType2.default)('ColoringRecord').isRequired,
  showThreadList: _react.PropTypes.func.isRequired,
  showThreadListButton: _react.PropTypes.bool.isRequired,
  unseenThreadsCountExcludingCurrentThread: _react.PropTypes.number.isRequired
};

exports.default = WidgetHeaderThreadListButton;